import React, { useEffect, useState } from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import { useFormik } from 'formik';
import * as Yup from 'yup';
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import Grid from "@mui/material/Grid";
import Card from "@mui/material/Card";
import { Checkbox, FormControlLabel, IconButton, TextField } from '@mui/material';
import DeleteIcon from '@mui/icons-material/Delete';
import DashboardLayout from 'examples/LayoutContainers/DashboardLayout';
import DashboardNavbar from 'examples/Navbars/DashboardNavbar';
import Footer from "examples/Footer";
import MDBox from 'components/MDBox';
import MDTypography from 'components/MDTypography';
import MDButton from 'components/MDButton';
import axios from 'axios';

export default function EditPermissions() {
    const { id } = useParams();
    const apiUrl = process.env.REACT_APP_API_BASE_URL;
    const bearerToken = localStorage.getItem('token');
    const navigate = useNavigate();
    const [isLoading, setIsLoading] = useState(false);
    const [rules, setRules] = useState([]);

    useEffect(() => {
        const fetchPermission = async () => {
            if (!bearerToken) return;
            try {
                const response = await axios.get(`${apiUrl}auth-service/permission/${id}`, {
                    headers: { Authorization: `Bearer ${bearerToken}` }
                });
                if (response.data?.success && response.data?.data) {
                    console.log(response.data?.data)
                    const permission = response.data?.data;
                    editPermission.setValues({
                        name: permission.name,
                        rules: permission.rules,
                    });
                    setRules(permission.rules);
                } else {
                    throw new Error("Failed to fetch permission data");
                }
            } catch (error) {
                console.log(error.response?.data?.message || error.message);
            }
        };
        fetchPermission();
    }, [id]);

    const editPermission = useFormik({
        initialValues: {
            name: '',
            rules: [],
        },
        validationSchema: Yup.object({
            name: Yup.string().required('Required'),
        }),
        onSubmit: async (values, { resetForm }) => {
            setIsLoading(true);
            try {
                const payload = { name: values.name, rules };
                const response = await axios.put(`${apiUrl}auth-service/permission/${id}`, payload,
                    {
                        headers: { 'Authorization': `Bearer ${bearerToken}` }
                    });
                if (response.data?.success) {
                    toast.info(response.data?.message || 'Permission has been successfully updated!');
                } else {
                    throw new Error('Failed to update permission');
                }
            } catch (error) {
                console.error('Error submitting form:', error.message);
                setIsLoading(false);
            } finally {
                resetForm();
                setTimeout(() => {
                    navigate(-1);
                }, 1500);
                setIsLoading(false);
            }
        },
    });

    const handleRuleChange = (index, field, value) => {
        const updatedRules = [...rules];
        updatedRules[index][field] = value;
        setRules(updatedRules);
    };

    const handleAddRule = () => {
        setRules([...rules, { name: '', access: false }]);
    };

    const handleRemoveRule = (index) => {
        const updatedRules = rules.filter((_, i) => i !== index);
        setRules(updatedRules);
    };

    return (
        <DashboardLayout><DashboardNavbar /> <MDBox pt={6} pb={3}>
            <Grid container spacing={6}>
                <Grid item xs={12}>
                    <form onSubmit={editPermission.handleSubmit}>
                        <Card>
                            <MDBox
                                mx={2}
                                mt={-3}
                                py={3}
                                px={2}
                                variant="gradient"
                                bgColor="info"
                                borderRadius="lg"
                                coloredShadow="info"
                                display="flex"
                                justifyContent="space-between"
                            >
                                <MDTypography variant="h6" color="white">
                                    Manage Permission
                                </MDTypography>
                            </MDBox>
                            <MDBox p={2}>
                                <Grid container spacing={5} display={'flex'} flexDirection={'row'}>
                                    <Grid item xs={6}>
                                        <MDBox p={1}>
                                            <TextField
                                                fullWidth
                                                variant="outlined"
                                                id="name"
                                                label="Name"
                                                name="name"
                                                value={editPermission.values.name}
                                                onChange={editPermission.handleChange}
                                                onBlur={editPermission.handleBlur}
                                                error={editPermission.touched.name && Boolean(editPermission.errors.name)}
                                                helperText={editPermission.touched.name && editPermission.errors.name} />
                                        </MDBox>
                                        <MDBox p={1}>
                                            <MDTypography variant="h6">Rules</MDTypography>
                                            {rules.map((rule, index) => (
                                                <MDBox key={index} display="flex" alignItems="center" mb={2}>
                                                    <TextField
                                                        variant="outlined"
                                                        label="Rule Name"
                                                        value={rule.name}
                                                        onChange={(e) =>
                                                            handleRuleChange(index, 'name', e.target.value)
                                                        }
                                                        style={{ marginRight: '10px' }}
                                                    />
                                                    <FormControlLabel
                                                        control={
                                                            <Checkbox
                                                                checked={rule.access}
                                                                onChange={(e) =>
                                                                    handleRuleChange(index, 'access', e.target.checked)
                                                                }
                                                            />
                                                        }
                                                        label="Access"
                                                    />
                                                    <IconButton onClick={() => handleRemoveRule(index)}>
                                                        <DeleteIcon />
                                                    </IconButton>
                                                </MDBox>
                                            ))}
                                            <MDButton variant="outlined" color="info" onClick={handleAddRule}>
                                                Add Rule
                                            </MDButton>
                                        </MDBox>
                                    </Grid>
                                </Grid>
                                <MDBox p={1} display={'flex'} flexDirection={'row'} alignItems='center'>
                                    <MDButton color='info' type='submit' sx={{ mr: 1 }} disabled={isLoading}>Update</MDButton>
                                    {isLoading &&
                                        <MDTypography variant='body2' ml={1}>updating....</MDTypography>
                                    }
                                </MDBox>
                            </MDBox>
                        </Card>
                    </form>
                </Grid>
            </Grid>
        </MDBox>
            <Footer />
            <ToastContainer
                position="bottom-right"
                autoClose={5000}
                hideProgressBar={false}
                newestOnTop={false}
                closeOnClick
                rtl={false}
                pauseOnFocusLoss
                draggable
                pauseOnHover
                theme="light"
            />
        </DashboardLayout>
    )
}